import { useUserQuery } from "~graphql/generated/graphql"
import { useAuth } from "~utils/auth-hooks"

// Passing false to shouldSkipIfNotAuthenticated will allow this to fetch guest users.
// We want to avoid this anywhere where the user will be shown in the UI.
export default function useUser({
    shouldSkipIfNotAuthenticated = true,
}: {
    shouldSkipIfNotAuthenticated?: boolean
} = {}) {
    const { accessToken, isAuthenticated } = useAuth()
    const hasAuthIfNeeded = !shouldSkipIfNotAuthenticated || isAuthenticated

    const {
        data,
        loading: isLoading,
        error,
    } = useUserQuery({ skip: !accessToken || !hasAuthIfNeeded })

    const user = data?.user ?? null

    return { user, isLoading, error }
}
